import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { createPayment } from "../../../../domain/payment/paymentActions";
import PayNowForm from "../../../forms/secure/PayNowForm/PayNowForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { retrieveProfile } from "../../../../domain/profile/profileActions";
import "./PayNow.less";
import { getRoutePaymentStatus } from "../../../../domain/payment/paymentUtils";
import WithAccount, { AccountLoadStatus } from "../WithAccounts/WithAccount";
import { push as pushUrl, replace as replaceUrl } from "react-router-redux";
import { backToUrl } from "assets/scripts/domain/misc/miscActions";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import { FormattedMessage } from "react-intl";
import MiscRepository from "assets/scripts/domain/misc/MiscRepository";
import track from "react-tracking";
class PayNow extends Component {
    constructor() {
        super(...arguments);
        this._handleStepForward = (step) => this._step(step, "forward");
        this._handleStepBack = (step) => this._step(step, "back");
    }
    componentDidMount() {
        this._stepCheck(true);
        if (!this.props.isLoadingProfile && !this.props.hasLoadedProfile) {
            this.props.retrieveProfile();
        }
        MiscRepository.trackEvent({
            event: "PaymentStart",
            payableId: this.props.params.id
        });
    }
    componentDidUpdate(prevProps) {
        this._stepCheck(prevProps.params.id !== this.props.params.id
            || prevProps.location.query.type !== this.props.location.query.type);
    }
    _stepCheck(newPayment) {
        const step = this._getStep();
        if (step == null) {
            this.props.onInvalidStep();
        }
        else if (newPayment && step !== "payment") {
            // must start on the first step, can't jump directly to a later one
            this._step("payment", "redirect");
        }
    }
    _renderBody(group) {
        if (group == null) {
            return (<StatusMessage isError isActive customMessage={StatusMessages.PAYMENT.ACCOUNT_NOT_FOUND} domain={"payment"}/>);
        }
        const { paymentAllowed, message } = getRoutePaymentStatus(group);
        if (!paymentAllowed) {
            return (<div className="vr vr_x5">
					<span className="text error">
						{message}
					</span>
				</div>);
        }
        let settlementOffer;
        let nextPayment;
        if (this.props.location.query.type != null) {
            const { settlementInfo } = group.primary;
            switch (this.props.location.query.type.toLowerCase()) {
                case "settlement":
                    if (settlementInfo.currentStep !== "OfferAccepted"
                        || settlementInfo.offer == null
                        || settlementInfo.offer.status !== "Accepted") {
                        return (<div className="vr vr_x5">
								<span className="text error">
									<FormattedMessage id="payNow.settlementNotValid" defaultMessage="The offer is no longer available."/>
								</span>
							</div>);
                    }
                    settlementOffer = settlementInfo.offer;
                    break;
                case "paymentplan":
                    nextPayment = settlementInfo.nextPayment || undefined;
                    break;
            }
        }
        const step = this._getStep();
        if (step == null) {
            return null;
        }
        return (<PayNowForm key={this.props.params.id} profile={this.props.profile} group={group} onCreatePayment={this.props.onCreatePayment} error={this.props.error} isSaving={this.props.isSaving} step={step} onStepForward={this._handleStepForward} onStepBack={this._handleStepBack} settlementOffer={settlementOffer} nextPayment={nextPayment}/>);
    }
    _getStep() {
        const { step } = this.props.params;
        switch (step) {
            case "payment":
            case "confirm":
                return step;
            case "banking":
            case "personal":
                return process.env.FEATURE_PAYMENT_WIZARD ? step : null;
            default:
                return null;
        }
    }
    render() {
        const { props } = this;
        const acctId = tryParseNumber(props.params.id);
        return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
				<WithAccount acctId={acctId || -1}>
					{account => (<Fragment>
							<StatusMessage isLoad isActive={account.loading || props.isLoadingProfile}/>

							<AccountLoadStatus loading={false} error={account.error}/>

							{!account.loading && !props.isLoadingProfile && account.error == null && (this._renderBody(account.acct))}
						</Fragment>)}
				</WithAccount>
			</div>);
    }
    _step(step, type) {
        this.props.onStep(step, parseInt(this.props.params.id, 10), type);
    }
}
const mapStateToProps = (state) => ({
    isLoadingProfile: state.profile.isLoading,
    hasLoadedProfile: !state.profile.isLoading && state.profile.profile != null,
    profile: state.profile.profile,
    error: state.payment.error,
    isSaving: state.payment.isSaving
});
function onStep(step, acctId, type) {
    return (dispatch, getState) => {
        const urlForAccount = `/secured/payNow/${acctId}`;
        let url = `${urlForAccount}/${step}`;
        const { pathname, search } = getState().routing.locationBeforeTransitions;
        if (pathname.toLowerCase().startsWith(urlForAccount.toLowerCase())) {
            url += search;
        }
        switch (type) {
            case "forward":
                return dispatch(pushUrl(url));
            case "back":
                return dispatch(backToUrl(url));
            case "redirect":
                return dispatch(replaceUrl(url));
            default:
                throw new Error("Unexpected state");
        }
    };
}
function onInvalidStep() {
    // treat like any other unknown url and redirect to dashboard
    return replaceUrl("/secured");
}
const bindActionsToProps = {
    retrieveProfile,
    onCreatePayment: createPayment,
    onStep,
    onInvalidStep
};
export default track({ page: "PayNow" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(PayNow));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/PayNow/PayNow.tsx